import photo001 from '../assets/images/gorod/001.png';
import photo002 from '../assets/images/gorod/002.jpg';

const gorod = {
    photos: [photo001, photo002],
    text: [
        'Медиаплатформа, история которой началась в 1998 году с одноименного телеканала, дает горожанам и неравнодушным к Северу жителям планеты разные возможности быть в курсе оперативных и актуальных новостей.',
        'Сегодня «Северный город» — это телекомпания, две радиостанции, три новостных портала, один из которых англоязычный, и ряд аккаунтов в социальных сетях.',
        'Новости, спецпроекты, авторские передачи, прямые трансляции культурных и спортивных событий — все это позволяет создать полноценную картину о жизни города. Мы открыты для всех, кто желает побольше узнать о Норильске, Таймыре и Красноярском крае, погрузиться в атмосферу северного города и стать частью Русской Арктики.'
    ]
};

export default gorod;
